export enum PlannedRouteClosureReason
{
    DriverAllocationIssue = 1,
    DriverNotLoggedOn = 2,
    JobCancelled = 3,
    JobNotExecuted = 4,
    NoTracking = 5,
    PlanningOrVettingIssue = 6,
    SystemIssue = 7,
    SystemOutage = 8,
    UnroadworthyEquipment = 9,
    VehicleAllocationIssue = 10,
    VehicleBreakdown = 11,
    OtherReason = 12
}
